import * as React from 'react';
import classNames from 'classnames';
import useInsertStyles from './utils/useInsertStyles';
import svgBaseProps from './utils/svgBaseProps';
import { error } from '../_util/devConsoleLog';
import { jsx as _jsx } from "react/jsx-runtime";
const Icon = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    // affect outter <i>...</i>
    className,
    // affect inner <svg>...</svg>
    component: Component,
    viewBox,
    spin,
    rotate,
    tabIndex,
    onClick,
    // children
    children,
    style,
    ...restProps
  } = props;
  error(!Boolean(Component || children), 'Icon', 'Should have `component` prop or `children`.');
  useInsertStyles();
  const classString = classNames('anticon', {
    'anticon-spin': !!spin
  }, className);

  // const svgClassString = classNames({
  //   'anticon-spin': !!spin,
  // });

  // const svgStyle = rotate
  //   ? {
  //       msTransform: `rotate(${rotate}deg)`,
  //       transform: `rotate(${rotate}deg)`,
  //     }
  //   : undefined;

  const innerSvgProps = {
    ...svgBaseProps,
    //className: svgClassString,
    //style: svgStyle,
    viewBox
  };
  if (!viewBox) {
    delete innerSvgProps.viewBox;
  }

  // component > children
  const renderInnerNode = () => {
    if (Component) {
      return /*#__PURE__*/_jsx(Component, {
        ...innerSvgProps,
        children: children
      });
    }
    if (children) {
      error(!(Boolean(viewBox) || React.Children.count(children) === 1 && /*#__PURE__*/React.isValidElement(children) && React.Children.only(children).type === 'use'), 'Icon', 'Make sure that you provide correct `viewBox`' + ' prop (default `0 0 1024 1024`) to the icon.');
      return /*#__PURE__*/_jsx("svg", {
        ...innerSvgProps,
        viewBox: viewBox,
        children: children
      });
    }
    return null;
  };
  let iconTabIndex = tabIndex;
  if (iconTabIndex === undefined && onClick) {
    iconTabIndex = -1;
  }
  return /*#__PURE__*/_jsx("span", {
    role: "img",
    ...restProps,
    ref: ref,
    tabIndex: iconTabIndex,
    onClick: onClick,
    className: classString,
    style: {
      ...style,
      ...(rotate ? {
        msTransform: "rotate(".concat(rotate, "deg)"),
        transform: "rotate(".concat(rotate, "deg)")
      } : {})
    },
    children: renderInnerNode()
  });
});
Icon.displayName = 'AntdIcon';
export default Icon;